/**
 * Gracefully ends a sentence with a dot if not provided.
 * @param sentence
 */
export const finishSentence = (sentence: string): string => (sentence.endsWith(".") ? sentence : `${sentence}.`);
